import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ exitUser, children }) => {
    const { pathname } = useLocation();
    const sliptPath = pathname.split("/");
    const authentication = ["login", "signup", "verify-otp", "forgot-password", "create-password"]
    const isAuthPage = authentication.includes(sliptPath?.[1]);
    const isCheckoutPage = pathname.includes("/checkout");
    const isUserVerifyPage = pathname.includes("/user-verification");
    const isProfilePage = pathname.includes("/profile");
    const isChatPage = pathname.includes("/chat");
    const isNotificationPage = pathname.includes("/notification");


    if (exitUser && isAuthPage) return <Navigate to="/" replace />;
    if (!exitUser && isCheckoutPage) return <Navigate to={`/user-verification?Type=service`} replace />;
    if (exitUser && isUserVerifyPage) return <Navigate to="/services/details/checkout" replace />;
    if (!exitUser && (isProfilePage || isChatPage || isNotificationPage)) return <Navigate to="/" replace />;

    return children;
};
